import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BlockIcon from "@material-ui/icons/Block";
import "./PricingTableStyle.css";
import SpButton from "../../components/atoms/SpButton";
import { labels } from "../shared/translations";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  getAuth0Roles,
  payment,
  subscription,
} from "../../models/actions/Common";
import moment from "moment";
import SpLoader from "../../components/atoms/SpLoader";
import { RegistrationPage } from "./RegistrationPage";
import LanguagesFlags from "../../components/bundles/LanguagesFlags";
import { withSnackbar } from "../../components/atoms/SpSnackBar";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import EventNoteIcon from "@material-ui/icons/EventNote";

const useStyles = makeStyles((theme) => ({
  rootLeft: {
    // display: "flex",
    position: "relative",
    height: "22em",
    width: "100%",
    overflow: "hidden",
    padding: "2em",
    marginLeft: "2em",
    marginRight: "2em",
  },

  right: {
    position: "relative",
    width: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export function CardDetails() {
  const classes = useStyles();

  return (
    <Grid container direction="row" justifyContent="center" spacing={2}>
      <Grid item xs={3}>
        <Card className={classes.rootLeft}>
          <Typography component="h5" variant="h5">
            {labels.manageUsers.digitalIDentityTitle}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {labels.manageUsers.digitalIDentitySubtitleHealth}
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2em",
              marginBottom: "2em",
            }}
          >
            <AccessibilityNewIcon style={{ color: "#31ccad", fontSize: 100 }} />
          </div>
        </Card>
      </Grid>
      <Grid item xs={3}>
        <Card className={classes.rootLeft}>
          <Typography component="h5" variant="h5">
            {labels.manageUsers.monitoringTitle}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {labels.manageUsers.monitorignSubtitle}
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2em",
              marginBottom: "2em",
            }}
          >
            <EqualizerIcon style={{ color: "#31ccad", fontSize: 100 }} />
          </div>
        </Card>
      </Grid>
      <Grid item xs={3}>
        <Card className={classes.rootLeft}>
          <Typography component="h5" variant="h5">
            {labels.manageUsers.activityPlanTitleHealth}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {labels.manageUsers.activityPlanSubtitleHealth}
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2em",
              marginBottom: "2em",
            }}
          >
            <EventNoteIcon style={{ color: "#31ccad", fontSize: 100 }} />
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}

export const userType = {
  healthAdmin: "Powerset Health Admin",
  performanceAdmin: "Powerset Performance Admin",
};

export const period = { year: "yearly" };

export const paymentTable = {
  "Powerset Health Admin": { monthly: 50, yearly: 600 },
  "Powerset Performance Admin": { monthly: 50, yearly: 600 },
};
const stripePromise = loadStripe(process.env.STRIPE);

const PaymentSection = (props) => {
  const stripe = useStripe();
  const [selectedPlan, setSelectedPlan] = useState(userType.healthAdmin);
  const [nMaxPatients, setnMaxPatients] = useState(50);
  const [loading, setLoading] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(period.year);
  const [expiredDate, setExpiredDate] = useState(moment().add(1, "year"));
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [formData, setFormData] = React.useState({});
  const elements = useElements();

  const PricingPlan = ({
    type,
    description,
    price,
    features,
    noAvailable,
    isSelected,
    action,
  }) => {
    return (
      <div
        class={!isSelected ? "basic-plan" : "basic-plan selected"}
        onClick={action}
      >
        <p className="price">{price}</p>
        <p>{description}</p>
        <ul>
          {features.map((feature) => (
            <li>
              <CheckCircleIcon className="icon" /> {feature}
            </li>
          ))}
          {noAvailable.map((feature) => (
            <li>
              <BlockIcon className="icon" /> {feature}
            </li>
          ))}
        </ul>
        {isSelected && (
          <Grid item xs={12}>
            <SpButton
              buttonType={"accept"}
              style={{ marginTop: "2em", width: "100%" }}
              onClick={() => {
                setShowRegistration(true);
              }}
              text={labels.manageUsers.payment}
            />
          </Grid>
        )}
      </div>
    );
  };

  const createProfessional = async () => {
    if (
      formData?.name &&
      formData?.surname &&
      formData?.email &&
      formData?.password &&
      formData?.ragionesociale &&
      formData?.address &&
      formData?.city &&
      formData?.cap &&
      formData?.paese &&
      formData?.piva &&
      formData?.fiscalcode &&
      privacyPolicy
    ) {
      setLoading(true);
      try {
        if (!stripe || !elements) {
          // Stripe.js non è ancora stato caricato o il componente è stato dismontato.
          setLoading(false);
          return;
        }

        const userMetadata = {
          expiry_date: `${moment(expiredDate).format(
            "YYYY-MM-DD"
          )}T22:59:59+01:00`,
          name: formData.name,
          surname: formData.surname,
          subscription_type: selectedPlan,
          n_max_patients: nMaxPatients,
        };

        const roles = await getAuth0Roles({});

        const res = await subscription({
          period: selectedPeriod,
          type: "health",
          amount: paymentTable[selectedPlan][selectedPeriod],
          n_max_patients: nMaxPatients,
          dataUser: {
            email: formData.email,
            password: formData.password,
            ragionesociale: formData.ragionesociale,
            address: formData.address,
            city: formData.city,
            cap: formData.cap,
            paese: formData.paese,
            piva: formData.piva,
            fiscalcode: formData.iscalcode,

            metadata: userMetadata,
            roles: [roles.find(({ name }) => name === selectedPlan)?.id],
            type: selectedPlan,
          },
        });
        if (res.error) {
          props.snackbarShowErrorMessage(res.error);
          setLoading(false);
        } else {
          const result = stripe.redirectToCheckout({
            sessionId: res.id,
          });
          if (result.error) {
            props.snackbarShowErrorMessage(result.error);
            setLoading(false);
          }
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        props.snackbarShowErrorMessage(error);
      }
    } else {
      setLoading(false);
      props.snackbarShowErrorMessage("Enter all the informations");
    }
  };

  useEffect(() => {
    let newDate;
    if (selectedPeriod === period.month) {
      newDate = moment().add(1, "months");
    }
    if (selectedPeriod === period.year) {
      newDate = moment().add(1, "year");
    }
    setExpiredDate(newDate);
  }, [selectedPeriod]);

  return (
    <Grid container className="backgroundPricing">
      {loading && <SpLoader />}
      {React.Children.map(props.children, (child) =>
        React.cloneElement(child, {
          setLoading: setLoading,
          componentName: props.componentName,
        })
      )}
      <Grid container direction="row" justifyContent="center" spacing={1}>
        {showRegistration && (
          <RegistrationPage
            formData={formData}
            setFormData={setFormData}
            createProfessional={createProfessional}
            setPrivacyPolicy={setPrivacyPolicy}
            privacyPolicy={privacyPolicy}
          />
        )}

        {!showRegistration && (
          <>
            <Grid
              container
              justifyContent="center"
              spacing={1}
              style={{ paddingTop: "2em" }}
            >
              <Grid
                container
                alignContent="center"
                item
                xs={12}
                alignItems="center"
                justifyContent="center"
                style={{ marginBottom: "2em" }}
              >
                <CardDetails />
              </Grid>
              {/* <Grid item>
                <ToggleButtonGroup size="small" exclusive>
                  <ToggleButton
                    value={labels.registrationPage.month}
                    onClick={() => {
                      setSelectedPeriod(period.month);
                      setSelectedPlan(userType.healthAdmin);
                    }}
                    style={{ boxShadow: "none", border: "none" }}
                    sx={{
                      boxShadow: "none !important",
                      border: "none !important",
                      background: "transparent",
                    }}
                  >
                    <div
                      class={
                        selectedPeriod === period.month
                          ? "toggle-plan selected"
                          : "toggle-plan"
                      }
                    >
                      <p className="toggle-plan-price">
                        {labels.registrationPage.month}
                      </p>
                    </div>
                  </ToggleButton>
                  <ToggleButton
                    value={labels.registrationPage.year}
                    onClick={() => {
                      setSelectedPeriod(period.year);
                      setSelectedPlan(userType.healthAdmin);
                    }}
                    style={{ boxShadow: "none", border: "none" }}
                    sx={{
                      boxShadow: "none !important",
                      border: "none !important",
                      background: "transparent",
                    }}
                  >
                    <div
                      class={
                        selectedPeriod === period.year
                          ? "toggle-plan selected"
                          : "toggle-plan"
                      }
                    >
                      <p className="toggle-plan-price">
                        {labels.registrationPage.year}
                      </p>
                    </div>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid> */}
            </Grid>
            <Grid
              container
              justifyContent="center"
              spacing={1}
              style={{ paddingTop: "2em" }}
            >
              <Grid item>
                <PricingPlan
                  description={""}
                  isSelected={
                    nMaxPatients == 50 && selectedPlan == userType.healthAdmin
                  }
                  action={() => {
                    setSelectedPlan(userType.healthAdmin);
                    setnMaxPatients(50);
                  }}
                  type={userType.healthAdmin}
                  price={
                    selectedPeriod === period.month
                      ? `€50${labels.manageUsers.month}`
                      : `€600${labels.manageUsers.year}`
                  }
                  features={[labels.manageUsers.upTo1]}
                  noAvailable={[]}
                />
              </Grid>
              <Grid item>
                <PricingPlan
                  description={""}
                  isSelected={
                    nMaxPatients == 200 && selectedPlan == userType.healthAdmin
                  }
                  action={() => {
                    setSelectedPlan(userType.healthAdmin);
                    setnMaxPatients(200);
                  }}
                  type={userType.healthAdmin}
                  price={
                    selectedPeriod === period.month
                      ? `€65${labels.manageUsers.month}`
                      : `€780${labels.manageUsers.year}`
                  }
                  features={[labels.manageUsers.upTo2]}
                  noAvailable={[]}
                />
              </Grid>
              <Grid item>
                <PricingPlan
                  description={""}
                  isSelected={
                    nMaxPatients == 1000 && selectedPlan == userType.healthAdmin
                  }
                  action={() => {
                    setSelectedPlan(userType.healthAdmin);
                    setnMaxPatients(1000);
                  }}
                  type={userType.healthAdmin}
                  price={
                    selectedPeriod === period.month
                      ? `€90${labels.manageUsers.month}`
                      : `€1080${labels.manageUsers.year}`
                  }
                  features={[labels.manageUsers.upTo3]}
                  noAvailable={[]}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

const PaymentPageHealth = (props) => {
  return (
    <div className="backgroundPricing">
      <Grid container direction="row">
        <Grid item xs={10}></Grid>
        <Grid item xs={2}>
          <LanguagesFlags />
        </Grid>
      </Grid>
      <Elements stripe={stripePromise}>
        <PaymentSection {...props} />
      </Elements>
    </div>
  );
};
export default withSnackbar(PaymentPageHealth);
